import { CookieAttributes } from 'js-cookie'

const COOKIE_OPTIONS = {
    expires: 365 * 2, // 2 years
    path: '/',
    sameSite: 'strict',
}

export const cookies: CookieAttributes = {
    ACCESS_TOKEN: 'access_token',
    OPTIONS: COOKIE_OPTIONS,
    REFRESH_TOKEN: 'refresh_token',
}
